// extracted by css-extract-rspack-plugin
export default {"icon":"_2d971210"};